export function databaseManifestColors() {
  return {
    red: "#FF6B6B",
    blue: "#4ECDC4",
    green: "#79B473",
    slate: "#577590",
    raspberry: "#950952"
  };
}
